// Блок вкладки «Состав тела»: цели из отчёта, нормы питания, домашние весы с поправкой.

import type { InBodySummaryOut } from '../api'
import { GoalButtons } from './GoalButtons'
import { NutritionCard } from './NutritionCard'
import { useZeppSamples } from './zepp'
import { ZeppChartCard } from './ZeppChartCard'

export function TargetsSection({ summary }: { summary: InBodySummaryOut }) {
  // Без записей Zepp сравнивать нечего — график не рисуем.
  const zepp = useZeppSamples('weight')
  const hasZepp = (zepp.data ?? []).length > 0
  return (
    <>
      <GoalButtons latest={summary.latest} />
      {summary.nutrition ? <NutritionCard nutrition={summary.nutrition} /> : null}
      {hasZepp ? <ZeppChartCard /> : null}
    </>
  )
}
